/** @format */

import { api } from 'utility';
import { getHasheFile } from 'URLs';

async function getHashe(data) {
  return api.post(getHasheFile(), data).then((res) => res.data);
}

export default { getHashe };
